import React from 'react';
import { ShopGenderSelectorProps } from '../interfaces';
import './ShopGenderSelector.scss';

const shopGenderOptions = [
  { label: 'All', value: '' },
  { label: 'Women', value: 'womens' },
  { label: 'Men', value: 'mens' },
];

const ShopGenderSelector: React.FC<ShopGenderSelectorProps> = ({ value, onChange }) => {
  const activeGenderIndex = shopGenderOptions.findIndex((option) => option.value === value);

  return (
    <div
      className="header-nav__shop-gender-toggle"
      role="radiogroup"
      aria-label="Choose catalog gender"
      data-active-index={activeGenderIndex >= 0 ? activeGenderIndex : 0}
    >
      <span className="header-nav__shop-gender-indicator" aria-hidden="true" />
      {shopGenderOptions.map((option) => (
        <button
          key={option.label}
          type="button"
          role="radio"
          aria-checked={value === option.value}
          className={value === option.value ? 'is-active' : ''}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default ShopGenderSelector;
